import { api } from '../core/api';

import {
  CounterQtyFilterByDateRequest,
  CounterQtyFilterByRelativeRequest,
} from '../../types/app/dashboard.types';
import {
  CycleTimeActualRequest,
  CycleTimeFilterByDateRequest,
  CycleTimeFilterByRelativeRequest,
} from '../../types/app/monitoredCycleTime.types';
import {
  StateActualRequest,
  StateFilterByDateRequest,
  StateFilterByRelativeRequest,
} from '../../types/app/monitoredState.types';

export const readCounterQtyFilterByRelative = (data: CounterQtyFilterByRelativeRequest) =>
  api
    .get(
      `MachineData/ReadCounterQtyFilterByRelative?machine=${data.machine}` +
        (data.start ? `&start=${data.start}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.stop ? `&stop=${data.stop}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readCounterQtyFilterByDate = (data: CounterQtyFilterByDateRequest) =>
  api
    .get(
      `MachineData/ReadCounterQtyFilterByDate?machine=${data.machine}` +
        (data.dateFrom ? `&dateFrom=${data.dateFrom}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.dateTo ? `&dateTo=${data.dateTo}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readCounterQtyFilterByDateTest = async (data: CounterQtyFilterByDateRequest) =>
  api
    .get(
      `MachineData/ReadCounterQtyFilterByDate?machine=${data.machine}` +
        (data.dateFrom ? `&dateFrom=${data.dateFrom}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.dateTo ? `&dateTo=${data.dateTo}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readScrapFilterByDate = (data: CounterQtyFilterByDateRequest) =>
  api
    .get(
      `MachineData/ReadCounterScrapFilterByDate?machine=${data.machine}` +
        (data.dateFrom ? `&dateFrom=${data.dateFrom}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.dateTo ? `&dateTo=${data.dateTo}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const getDataForMainDashboard = (data: any) =>
  api
    .get(
      `Asset/GetDataForMainDashboard?assetId=${data.assetId}&machine=${data.machine}` +
        (data.dataId ? `&counterQtyDataId=${data.dataId}` : '') +
        (data.cycleTimeDataId ? `&cycleTimeDataId=${data.cycleTimeDataId}` : '') +
        (data.stateDataId ? `&stateDataId=${data.stateDataId}` : '') +
        (data.dateFrom ? `&shiftFrom=${data.dateFrom}` : '') +
        (data.dateTo ? `&shiftTo=${data.dateTo}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : '') +
        (data.hydraMachineNr ? `&hydraMachineNr=${data.hydraMachineNr}` : ''),
    )
    .then((res) => res.data);

export const readCycleTimeFilterByDate = (data: CycleTimeFilterByDateRequest) =>
  api
    .get(
      `MachineData/ReadCycleTimeFilterByDate?machine=${data.machine}` +
        (data.dateFrom ? `&dateFrom=${data.dateFrom}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.dateTo ? `&dateTo=${data.dateTo}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readCycleTimeFilterByRelative = (data: CycleTimeFilterByRelativeRequest) =>
  api
    .get(
      `MachineData/ReadCycleTimeFilterByRelative?machine=${data.machine}` +
        (data.start ? `&start=${data.start}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.stop ? `&stop=${data.stop}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readCycleTimeActual = (data: CycleTimeActualRequest) =>
  api
    .get(
      `MachineData/ReadCycleTimeActual?machine=${data.machine}` +
        (data.dataId ? `&dataId=${data.dataId}` : ''),
    )
    .then((res) => res.data);

export const readStateFilterByDate = (data: StateFilterByDateRequest) =>
  api
    .get(
      `MachineData/ReadStateFilterByDate?machine=${data.machine}` +
        (data.dateFrom ? `&dateFrom=${data.dateFrom}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.dateTo ? `&dateTo=${data.dateTo}` : ''),
      //(data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readStateFilterByRelative = (data: StateFilterByRelativeRequest) =>
  api
    .get(
      `MachineData/ReadStateFilterByRelative?machine=${data.machine}` +
        (data.start ? `&start=${data.start}` : '') +
        (data.dataId ? `&dataId=${data.dataId}` : '') +
        (data.stop ? `&stop=${data.stop}` : '') +
        (data.aggregation ? `&aggregation=${data.aggregation}` : ''),
    )
    .then((res) => res.data);

export const readStateActual = (data: StateActualRequest) =>
  api
    .get(
      `MachineData/ReadStateActual?machine=${data.machine}` +
        (data.dataId ? `&dataId=${data.dataId}` : ''),
    )
    .then((res) => res.data);
